import convertorMixin from '@/mixins/convertor-mixin.js' // 引入mixin文件

export default {
  name: 'AddDataNode',
  data () {
    return {
      tableData: [],
      tableTotalRow: 0,
      // 遮罩层
      loading: true,
      // 查询条件
      tableQueryParams: {
        regionId: 0,
        nodeId: 0,
        descendantRegionRequired: 1,
        resourceKind: 23,
        gaugedObjectKind: 255,
        alarmStates: [],
        systemKind: 0,
        encoderStateRequired: 0, // 要求返回监控设备状态
        pageNum: 1,
        pageSize: 10
      },
      // 表格选中记录数组
      tableSelectedIds: [],
      // 记录编辑
      addParams: {
        dataNodes: []
      }
    }
  },
  props: {
    modalOpen: {
      type: Boolean,
      default: false
    },
    regionId: {
      type: Number,
      default: 0
    },
    gaugedObjectKind: {
      type: Number,
      default: 255
    }
  },
  mixins: [
    convertorMixin
  ],
  mounted () {
    this.getDataNodeList()
  },
  methods: {
    // 获取数据节点列表
    getDataNodeList() {
      this.tableQueryParams.regionId = this.regionId
      this.tableQueryParams.gaugedObjectKind = this.gaugedObjectKind
      this.$http(this.$api.dataNodeList, this.tableQueryParams).then(
        res => {
          if (res.code === 200) {
            this.tableData = res.data
            this.tableTotalRow = res.page.totalRow
          }
        }
      )
    },
    // 表格选中记录改变
    handleTableSelectionChange (selection) {
      this.tableSelectedIds = selection.map(item => item.id)
      this.addParams.dataNodes = selection
    },
    // 分页
    handleTableCurrentChange (val) {
      this.tableQueryParams.pageNum = val
      this.getDataNodeList()
    },
    // 提交编辑结果
    handleModalSubmit () {
      this.$emit('submit', this.addParams)
    },
    // 取消提交记录
    handleModalCancel () {
      this.$emit('cancel', false)
      this.$refs.table.clearSelection()
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/common/showDataNode/addDataNode/AddDataNode.js